import React  from 'react';
import './result-page-wrapper.css';

export const ResultPageWrapper = ({ colors, backgroundImage, targetBuilderType, children, isFullScreen = false, hideResultContainer = false }) => {

    return (
        <div
            className={`result-page-container ${isFullScreen ? 'full-screen ' : ''} ${backgroundImage ? 'with-image' : ''}`}
            style={{
                backgroundColor: colors[targetBuilderType].backgroundColor,
                backgroundImage: backgroundImage ? 'url(' + backgroundImage + ')' : 'unset'
            }}
        >
            {
                !hideResultContainer &&
                <div className="result-container">
                    { children }
                </div>
            }
        </div>
    );
}
